import { observer } from "mobx-react-lite";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import "../../style/Leaderboard.css";
import ProfilPlayerSmall from "./ProfilPlayerSmall";
import { ArrowDown, ArrowUp } from 'lucide-react';

const Leaderboard = observer(({ profilPlayerStore, className }) => {
    const [nbProfilPlayer, setNbProfilPlayer] = useState(6);

    // useEffect(()=>{

    //     // IMPORT PLAYER INFO
    //     profilPlayerStore.loadProfilPlayer(nbProfilPlayer);
    //     console.log(profilPlayerStore.profilPlayerList);

    // }, [])

    useEffect(()=>{
        // Changement de l'affichage leaderboard
        profilPlayerStore.loadProfilPlayer(nbProfilPlayer)
    }, [nbProfilPlayer])



  return (
    <aside className={`leaderboard_div ${className}`}>
      <h1 className="leaderboard_title">Leaderboard :</h1>
      <ul className={`leaderboard_list`}>
        {profilPlayerStore.profilPlayerList.map((profilPlayer, index) => 
          index>=nbProfilPlayer ? null :
          <li key={profilPlayer.id}>
            <ProfilPlayerSmall profilPlayer={profilPlayer} place={index + 1} />
          </li>
        )}
      </ul>
      <div className="leaderboard_buttonDiv">
        {nbProfilPlayer>3?<button onClick={()=>setNbProfilPlayer(prev => Math.max(3, prev - 3))} className="leaderboard_showLess">
            <p>Voir moins</p>
            <ArrowUp color={"#bbbbbb"}/>
        </button>:null}
        {profilPlayerStore.profilPlayerList.length>=nbProfilPlayer?<button onClick={()=>setNbProfilPlayer(prev=> prev+3)} className="leaderboard_showMore">
            <p>Voir plus</p>
            <ArrowDown color={"#bbbbbb"}/>
        </button>:null}
      </div>
    </aside>
  );
});
Leaderboard.propTypes = {};

export default Leaderboard;
